import moment from "moment";
import {
  mapGetters
} from 'vuex'
const base = {
  data() {
    return {
      screenWidth: 0
    }
  },
  mounted() {
    this.handleReSize = (e) => {
      this.screenWidth = document.body.clientWidth;

    }
    window.addEventListener('resize', this.handleReSize);
    this.handleReSize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleReSize)
  },
  computed: {
    calcFontSize() {
      return function(value, min) {
        let size = (value / 1920 * this.screenWidth);
        if (min) {
          if (size < min * value) {
            size = min * value;
          }
        }
        return size + 'px';
      }

    },

  },
  methods: {
    convertPos(value) {
      if (value === undefined) {
        return undefined;
      }
      let low = value & 0xff;
      let hight = value >> 8 & 0xff;

      return hight + "_" + low;
    },

    formatTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
    hasPermission(roles) {
      return roles.includes(this.$store.getters.roleId);
    },
    closeCurrentPageAndJumpToPage(params) {
      this.$store.dispatch("tagsView/delView", Object.assign({}, this.$route))
        .then(({
          visitedViews
        }) => {
          if (params) {
            this.$router.push(params);
          }

        });
    },
    toCachePage(params) {
      if (!params) {
        return;
      }
      let find = false;
      let visitedViews = this.$store.state.tagsView.visitedViews;
      if (visitedViews) {
        for (let i = 0; i < visitedViews.length; i++) {
          let view = visitedViews[i];


          if (view.name == params.name || view.path == params.path) {
            find = true;
            this.$store
              .dispatch("tagsView/delView", Object.assign({}, view))
              .then(({
                visitedViews
              }) => {

                this.$router.push(params);
              });

          }

        }
      }
      if (!find) {
        this.$router.push(params);
      }

      console.log(visitedViews);
    }

  }
}
export default base;
